
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/our-values",
      function () {
        return require("private-next-pages/about-us/our-values/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/our-values"])
      });
    }
  